import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Loader from '@/components/ui/Loader';
import { AUTH_MODES } from '@/configs/authMode';
import { ROUTES } from '@/configs/routes';
import LoginMethodPage from '@/pages/LoginMethodPage';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import { sessionStore } from '@/stores/global/RootStore';

/* HOC для страниц, для которых нужна авторизация */
export const withAuth = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  observer((props: P) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const {
      session,
      isAuthenticated,
      loadSession,
      authMode,
      loadSessionMeta: { isError },
    } = sessionStore;
    const totpEnabled = session?.identity.traits.totpEnabled ?? true;

    React.useEffect(() => {
      if (!isAuthenticated) {
        loadSession();
      }
    }, [isAuthenticated, loadSession]);

    React.useEffect(() => {
      if (isError && pathname !== ROUTES.root.path) {
        navigate(ROUTES.root.path, { replace: true });
      }
    }, [isError, navigate, pathname]);

    React.useEffect(() => {
      if (isAuthenticated && !totpEnabled) {
        navigate(ROUTES.auth.totpSetup.path, { replace: true });
      }
    }, [isAuthenticated, navigate, totpEnabled]);

    if (!isAuthenticated) {
      if (isError && pathname === ROUTES.root.path) {
        if (authMode === AUTH_MODES.ALFA_ID || authMode === AUTH_MODES.PHONE_TOTP_ONLY) {
          return <LoginMethodPage />;
        }

        return <UnauthorizedPage />;
      }

      return <Loader fullHeight />;
    }

    return <Component {...props} />;
  });
